import { FunctionComponent } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { TypeModalProps } from './types';
import { Close } from '@/icons';

export const Modal: FunctionComponent<TypeModalProps> = ({
  isButtonX = true,
  children,
  isOpen = true,
  closeModal,
  className = '',
}: TypeModalProps) => (
  <Dialog className="relative z-10" onClose={closeModal} open={isOpen} transition>
    <DialogBackdrop transition className="fixed inset-0 bg-black bg-opacity-25 transition ease-out duration-300 data-[closed]:opacity-0 data-[leave]:ease-in data-[leave]:duration-200" />
    <div className="fixed inset-0 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4 text-center">
        <DialogPanel
          transition
          className={`ease-out duration-300 data-[closed]:opacity-0 data-[closed]:scale-95 data-[leave]:ease-in data-[leave]:duration-200 data-[leave]:scale-100 w-full p-10 transform overflow-hidden bg-white text-left align-middle shadow-xl transition-all relative ${className}`}
        >
          {isButtonX && (
            <div className="flex justify-end absolute right-10 top-10 -translate-y-1/2">
              <button type="button" onClick={closeModal}>
                <Close width={24} height={24} />
              </button>
            </div>
          )}
          <div className="text-base text-gray-500">{children}</div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);

Modal.displayName = 'Modal';
